import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import drakesLogo from '../assets/drakes_logo.jpg';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={handleLinkClick}>
          <img src={drakesLogo} alt="Drake's San Carlos" />
        </Link>
        
        <button 
          className={`mobile-menu-button ${isMenuOpen ? 'active' : ''}`} 
          onClick={toggleMenu} 
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/" onClick={handleLinkClick} className={location.pathname === '/' ? 'active' : ''}>Home</Link>
          <Link to="/menu" onClick={handleLinkClick} className={location.pathname === '/menu' ? 'active' : ''}>Menu</Link>
          <Link to="/our-story" onClick={handleLinkClick} className={location.pathname === '/our-story' ? 'active' : ''}>Our Story</Link>
          <Link to="/private-events" onClick={handleLinkClick} className={location.pathname === '/private-events' ? 'active' : ''}>Private Events</Link>
          <Link to="/trivia" onClick={handleLinkClick} className={location.pathname === '/trivia' ? 'active' : ''}>Trivia</Link>
          <Link to="/live-music" onClick={handleLinkClick} className={location.pathname === '/live-music' ? 'active' : ''}>Live Music</Link>
          <Link to="/contact-us" onClick={handleLinkClick} className={location.pathname === '/contact-us' ? 'active' : ''}>Contact Us</Link>
          <Link to="/gift-cards" onClick={handleLinkClick} className={location.pathname === '/gift-cards' ? 'active' : ''}>Gift Cards</Link>
          <Link to="/catering" onClick={handleLinkClick} className={location.pathname === '/catering' ? 'active' : ''}>Catering</Link>
          <Link to="/reservations" onClick={handleLinkClick} className={location.pathname === '/reservations' ? 'active' : ''}>Reservations</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 